import Notification from "components/Settings/NotificationTab/index";
import React from "react";

function EmployeeNotification() {
  return (
    <>
      <Notification />
    </>
  );
}

export default EmployeeNotification;
